module.exports = __webpack_public_path__ + "dashboard.svg?ccdc730d7be833582f5347ccaebe2e66";